import React from 'react';
import { useAppTranslation } from '../i18n/useAppTranslation';
import { useAuth } from './AuthContext';
import styles from './SmallDeviceNotice.module.css';

/**
 * Shown to AUTHENTICATED users on phone-sized screens when an admin has enabled
 * the `ui.block_small_devices` setting. The public landing/login pages are never
 * affected — SessionGate only renders this on the logged-in app branch.
 * Chrome-free (no LeftNav/topbar), like AuthSplash.
 */
export default function SmallDeviceNotice() {
  const { t } = useAppTranslation('pages');
  const { logout } = useAuth();

  return (
    <div className={styles.screen} role="alert">
      <div className={styles.icon} aria-hidden="true">🖥️</div>
      <h1 className={styles.title}>
        {t('smallDevice.title', 'Life4Earth works best on a larger screen')}
      </h1>
      <p className={styles.body}>
        {t(
          'smallDevice.body',
          'Please open Life4Earth on a desktop, laptop, or tablet to continue. The full experience isn’t available on small phone screens yet.',
        )}
      </p>
      <button type="button" className={styles.signout} onClick={() => logout()}>
        {t('smallDevice.signOut', 'Sign out')}
      </button>
    </div>
  );
}
